export default (itemUser, currentUser) => {
  if (itemUser.id === currentUser.id) return "#7E47D3";
  return null;
};
